module.exports = __webpack_public_path__ + "static/media/21pic.86cd92a2.jpg";